export const PrivacyPolicyUrl = 'https://portal.join-tandem.com/privacy-policy';
export const ProviderTermsOfUseUrl = 'https://portal.join-tandem.com/tandem-terms-of-use/provider';
